module.exports = __webpack_public_path__ + "img/90.e2ed9a8b.png";